export const ItemTypes = {
  BOX: 'box',
  CARD: 'card'
}
